import { commentItems } from "@/mocks/homeData";

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            用户口碑
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            听听来自真实用户对黄桃视频的评价与使用感受
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {commentItems.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.author}</p>
                  <p className="text-[11px] text-foreground-400">{comment.date}</p>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}